import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import reportApi from "../../../../api/reportApi";
import { useReportFilters } from "../../contexts/ReportFiltersContext";
import EmptyState from "../../components/EmptyState";
import ReportSectionCard from "../../components/ReportSectionCard";
import ConversationVolumeChart from "./components/ConversationVolumeChart";
import ChatbotDeliveryCard from "./components/ChatbotDeliveryCard";

const ActivityReportPage = () => {
  const isChatbotEventEnabled = useSelector(
    (state) => state.chatbotEventAccess.enabled === true,
  );
  const { shopId, from, to, isRangeValid } = useReportFilters();
  const [volume, setVolume] = useState([]);
  const [delivery, setDelivery] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!shopId || !isRangeValid) return;
    let cancelled = false;
    setLoading(true);
    setError(null);
    Promise.all([
      reportApi.getConversationVolume({ shopId, from, to }),
      isChatbotEventEnabled
        ? reportApi.getChatbotDelivery({ shopId, from, to })
        : Promise.resolve({ status: 1, data: null }),
    ])
      .then(([v, d]) => {
        if (cancelled) return;
        if (v.status === 1) setVolume(v.data || []);
        if (d.status === 1) setDelivery(d.data);
        const err = [v, d].find((r) => r.status !== 1);
        if (err) setError(err.message || "Không tải được dữ liệu");
      })
      .catch((err) => !cancelled && setError(err.message))
      .finally(() => !cancelled && setLoading(false));
    return () => {
      cancelled = true;
    };
  }, [shopId, from, to, isRangeValid, isChatbotEventEnabled]);

  if (!shopId) {
    return (
      <div className="p-6">
        <EmptyState title="Chọn Zalo để xem báo cáo" />
      </div>
    );
  }

  return (
    <div className="p-4 space-y-4 max-w-7xl">
      <div>
        <h2 className="text-lg font-semibold text-gray-900">Hoạt động</h2>
        <p className="text-xs text-gray-500 mt-0.5">
          Hội thoại, tin nhắn và chatbot gửi tự động trong khoảng đã chọn
        </p>
      </div>

      {error && (
        <div className="p-3 bg-red-50 text-red-700 rounded text-sm">{error}</div>
      )}

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <ReportSectionCard
          className="lg:col-span-2"
          title="Hội thoại theo ngày"
          subtitle="Số tin khách gửi vs tin nhân viên gửi"
        >
          {loading && volume.length === 0 ? (
            <div className="h-[200px] bg-gray-50 rounded animate-pulse" />
          ) : (
            <ConversationVolumeChart data={volume} />
          )}
        </ReportSectionCard>

        {isChatbotEventEnabled && (
          <ReportSectionCard
            title="Gửi tự động"
            subtitle="Chatbot — tỷ lệ gửi, xem, thất bại"
          >
            {loading && !delivery ? (
              <div className="h-32 bg-gray-50 rounded animate-pulse" />
            ) : (
              <ChatbotDeliveryCard data={delivery} />
            )}
          </ReportSectionCard>
        )}
      </div>
    </div>
  );
};

export default ActivityReportPage;
